import { Reducer } from 'redux';
import { IFilter, MotoristaState, MotoristaTypes } from './types';

const INITIAL_STATE: MotoristaState = {
  data: [],
  dataDetalhesMotorista: [],
  error: false,
  loading: false,
  filter: {} as IFilter,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<MotoristaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MotoristaTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MotoristaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case MotoristaTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case MotoristaTypes.LOAD_DETALHES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MotoristaTypes.LOAD_DETALHES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        dataDetalhesMotorista: action.payload.dataDetalhesMotorista,
      };
    case MotoristaTypes.LOAD_DETALHES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        dataDetalhesMotorista: [],
      };
    case MotoristaTypes.FILTER:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case MotoristaTypes.CLEAN_MOTORISTA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
